module.exports = __webpack_public_path__ + "img/zhiwu4.0a6b9eba.jpg";